module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile-fc5fe2f01e552d9df3f0803c98c91476.jpg";